import {ImageRequestParams} from "../../models/image/image-request-params";

export class InvitationFailedBackgroundImageRequestParams extends ImageRequestParams {
  constructor(isMobile) {
    super({});

    this._resourceName = `bolao24/assets/invitation_Failed_background${isMobile ? '_mobile' : ''}`;
  }
}
